import { Container } from "unstated";

import localStorageHelper from "../utils/helpers/localStorageHelper";
import stringHelper from "../utils/helpers/stringHelper";

export default class StateContainer extends Container {
  constructor(props) {
    super(props);

    this.state = {
      jsonData: {},

      loadingProgress: 0,
      //We will get this value from the project json
      currentState: 0,
      currentRow: 0,
      currentColumn: 0,
      currentHotspotColumn: 0,
      maxColumns: 59,
      maxApartmentColumns: 59,

      rowsPerState: [],

      hotspotColors: {
        T1: {
          DefaultColor: "",
          DefaultOpacity: "",

          HoverColor: "",
          HoverOpacity: "",

          StrokeColor: "",
          StrokeOpacity: "",
        },
        T2: {
          DefaultColor: "",
          HoverColor: "",
          StrokeColor: "",
        },
        T3: {
          DefaultColor: "",
          HoverColor: "",
          StrokeColor: "",
        },
        T4: {
          DefaultColor: "",
          HoverColor: "",
          StrokeColor: "",
        },
        T5: {
          DefaultColor: "",
          HoverColor: "",
          StrokeColor: "",
        },
      },
      hotspotUnavailableColor: "",

      currentFilter: [],
      currentTags: [],
      priceFilter: {},
      priceValues: [],
      quadratureFilter: {},
      quadratureValues: [],

      fov: 100,
      spriteScale: 3,
      cameraDistanceMultiplier: 0.01,
      hotspotScale: 0.01,
      cameraZoom: 0,
      minZoom: 0,
      maxZoom: 0,
      zoomStep: 0.02,

      hotspotAngle: 0,
      compassStartingAngle: null,
      navbarScrollbarLogo: "./design/new-exports/mag_znak.png",

      isMouseOnSideBar: false,
      isSideBarOpen: false,
      isFullscreen: false,

      isMapShown: false,
      isCompareShown: false,
      isUpButtonShown: true,
      isDownButtonShown: true,
      isLeftButtonShown: true,
      isRightButtonShown: true,
      isCompasShown: true,
      isFilterMenuShown: true,
      isInvestorLogoShown: true,
      magLogoVisible: false,
      isFullscreenButtonShown: true,
      isApartmentFullscreenButtonShown: true,
      isMainMenuShown: true,
      isApartment3DCanvasShown: false,
      apartmentViewButton: true,
      apartment3DViewButton: true,

      orbViews: [],
      shouldDisplayOrbViewScene: false,

      calibratorEnabled: false,

      isApartmentInfoShown: false,
      apartmentClickedInfo: undefined,
      waitForImage: false,
      //Used in compare logic
      allApartments: [],
      linkHotspots: [],
      favouriteApartments: null,
      favouriteApartmentsDetails: [],
      //Drag variables
      startDragPosition: [0, 0],
      isClicked: false,
      isDragging: false,

      leftCompare3DContainerActive: false, 
      leftApartmentStyles: {
        D2: { display: "block" },
        D3: { display: "none" },
      },
      rightCompare3DContainerActive:  false, 
      rightApartmentStyles: {
        D2: { display: "block" },
        D3: { display: "none" },
      },

      carouselCompareSettings: {
        dots: false,
        infinite: true,
        arrows: true,
        speed: 200,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: false,
        className: "compare__header--apartment",
        responsive: [
          {
            breakpoint: 777,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 827,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1231,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1401,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1921,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 2,
            },
          },
        ],
      },
    };

    let angleStep = (2 * Math.PI) / this.state.maxColumns;
    this.state.hotspotAngle = -1 * angleStep * this.state.currentColumn;
    this.attachEventListeners();
  }

  /**
   * Gets an array of apartment keys from localstorage and sets them into state.
   */
  async fetchFavouriteApartments() {
    let favApartmentsDetails = [];
    let keys = window.localStorage.getItem("favourite-apartments");
    if (keys !== null) {
      keys = JSON.parse(keys);
      // Check the favourite apartment keys if they exist in list of all apartments.
      for (let i = 0; i < keys.length; i++) {
        if (this.state.allApartments[keys[i]] !== undefined) {
          favApartmentsDetails.push(this.state.allApartments[keys[i]]);
        }
      }
    } else {
      keys = [];
      localStorageHelper.setToLocal("favourite-apartments", keys);
      this.setState({ favouriteApartments: keys });
    }

    await this.setState({
      favouriteApartmentsDetails: favApartmentsDetails,
      favouriteApartments: keys,
    });
  }

  /**
   * Adds the passed apartment key to localstorage and that apartments info into a dictionary.
   * @param apartmentKey Key of the apartment we are adding
   */
  addFavourite(apartmentKey) {
    let favouriteApartmentsDetails = this.state.favouriteApartmentsDetails;
    if (this.state.allApartments[apartmentKey] !== undefined) {
      // Set up detail
      favouriteApartmentsDetails.push(this.state.allApartments[apartmentKey]);
      this.setState({ favouriteApartmentsDetails });
      // Set up key
      let tempFavourite = this.state.favouriteApartments;
      tempFavourite.push(apartmentKey);

      this.setState({ favouriteApartments: tempFavourite });

      let localApartments = window.localStorage.getItem("favourite-apartments");

      if (localApartments !== null) {
        window.localStorage.removeItem("favourite-apartments");
      }
      window.localStorage.setItem(
        "favourite-apartments",
        JSON.stringify(this.state.favouriteApartments)
      );
    }
  }

  /**
   * Removes the passed apartment key from localstorage and that apartments info from a dictionary.
   * @param apartmentKey Key of the apartment we are removing
   */
  async removeFavorite(apartmentKey) {
    let keys = this.state.favouriteApartments;
    let tempFavourite = this.state.favouriteApartmentsDetails;

    let indexOfKeys = keys.indexOf(apartmentKey);

    // Find and remove favourite apartment info.
    for (let i = 0; i < tempFavourite.length; i++) {
      if (tempFavourite[i].key === apartmentKey) {
        tempFavourite.splice(i, 1);
        this.setState({
          favouriteApartmentsDetails: tempFavourite,
        });
        break;
      }
    }

    // Remove favourite key from the array.
    if (indexOfKeys !== -1) {
      keys.splice(indexOfKeys, 1);
      await this.setState({
        favouriteApartments: keys,
      });
    }

    // Update Local Storage
    window.localStorage.setItem("favourite-apartments", JSON.stringify(keys));
  }

  /**
   * Toggles display of side menu.
   */
  toggleSideMenu() {
    this.setState({ isSideBarOpen: !this.state.isSideBarOpen });
  }

  /**
   * Turns off display of the compare page.
   */
  toggleCompareShownOff() {
    this.setState({
      isCompareShown: false,
      isApartmentInfoShown: false,
      apartmentClickedInfo: undefined,
    });

    let event = new CustomEvent("closeCompareWindow");
    window.dispatchEvent(event);
  }

  /**
   * Triggers an event to start rendering the main canvas.
   */
  renderMainCanvas() {
    let event = new CustomEvent("renderMainCanvas");

    let canvas = document.getElementById("full-screenable-node");
    canvas.dispatchEvent(event);
  }

  /**
   * Takes values from the statecontainer and dispatches them to an event to update the apartment 3D view texture.
   */
  updateApartmentTextureHandler() {
    let parameters = [];
    parameters.push(this.state.currentState);
    parameters.push(this.state.apartmentClickedInfo.key);
    parameters.push(this.state.currentHotspotColumn);

    let lowUrlPath =
      this.state.apartmentClickedInfo.lowResUrls[
        this.state.currentHotspotColumn
      ];
    parameters.push(lowUrlPath);
    let event = new CustomEvent("updateApartmentTexture", {
      detail: {
        parameters: parameters,
      },
    });

    window.dispatchEvent(event);
  }

  /**
   * Takes a an url to a font and imports and applies it.
   * @param fontUrl Url for the font hosted on umbraco
   */
  setProjectFont(fontUrl) {
    let css = "";

    if (fontUrl) {
      css = `@font-face {
        font-family: "Our font";
        src: url(${fontUrl});
      }`;
    }
    const style = document.createElement("style");
    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
    document.getElementsByTagName("head")[0].appendChild(style);
  }

  /**
   * Parses passed states array and sets an array of unavailable apartments into the state container.
   * @param states Array of states from the API
   */
  getUnavailableApartmentsAndFilters(states) {
    const unavailableApartments = [];
    const filters = [];
    states.forEach((state) => {
      if (state.apartments) {
        state.apartments.forEach((apartment) => {
          if (!apartment.isAvailable) {
            unavailableApartments.push(apartment.key);
          }
          if (!filters.includes(apartment.type) && apartment.type !== "") {
            filters.push(apartment.type);
          }
        });
      }
    });
    filters.sort();
    this.setState({ availableFilters: filters });
  }

  setCustomStateButtons(states, buttons) {
    let buttonArray = buttons;
    states.forEach((state) => {
      buttonArray.forEach((button) => {
        if (button.actions[0].parameter === state.name) {
          button.placementOrder = state.placementOrder;
        }
      });
    });
    buttonArray.sort((a, b) => a.placementOrder - b.placementOrder);
    return buttonArray;
  }

  setHotspotColors(hotspotColors) {
    let colors = ["T1", "T2", "T3", "T4", "T5"];

    let convertedColors = {};
    colors.forEach((colorKey) => {
      let defaultColors = stringHelper.convertRGBtoOBJ(
        hotspotColors[colorKey].defaultColor
      );
      let hoverColors = stringHelper.convertRGBtoOBJ(
        hotspotColors[colorKey].hoverColor
      );
      let strokeColors = stringHelper.convertRGBtoOBJ(
        hotspotColors[colorKey].strokeColor
      );

      convertedColors[colorKey] = {
        defaultColor: defaultColors[0],
        defaultOpacity: parseFloat(defaultColors[1]),

        hoverColor: hoverColors[0],
        hoverOpacity: parseFloat(hoverColors[1]),

        strokeColor: strokeColors[0],
        strokeOpacity: parseFloat(strokeColors[1]),
      };
    });

    return convertedColors;
  }

  /**
   * Function that is bound to an event.
   * Takes data from the API and stores it into state.
   * @param event Event parameter
   */
  async setJsonData(event) {
    this.angleStep = (2 * Math.PI) / event.detail.jsonData.maxColumns;
    this.getUnavailableApartmentsAndFilters(event.detail.jsonData.states);
    const states = event.detail.jsonData.states;

    let sortedButtons = this.setCustomStateButtons(
      event.detail.jsonData.states,
      event.detail.jsonData.skinEditor.customButtons
    );
    let hotspotColors = this.setHotspotColors(
      event.detail.jsonData.hotspotColors
    );

    let allApartments = [];
    let orbViews = [];
    let linkHotspots = [];
    let minPrice = 0;
    let maxPrice = 0;
    let minQuadrature = 0;
    let maxQuadrature = 0;

    // Load all Apartments into array.
    for (let i = 0; i < states.length; i++) {
      if (states[i].apartments.length > 0) {
        let apartments = states[i].apartments;
        for (let j = 0; j < apartments.length; j++) {
          if (apartments[j].isLink === true) linkHotspots.push(apartments[j]);
          // Find min and max price
          if (apartments[j].price !== undefined) {
            if (apartments[j].price < minPrice) {
              minPrice = apartments[j].price;
            } else if (apartments[j].price > maxPrice) {
              maxPrice = apartments[j].price;
            }
          }
          // Find min and max quadrature
          if (apartments[j].quadrature !== undefined) {
            if (apartments[j].quadrature < minQuadrature) {
              minQuadrature = apartments[j].quadrature;
            } else if (apartments[j].quadrature > maxQuadrature) {
              maxQuadrature = apartments[j].quadrature;
            }
          }
          allApartments[apartments[j].key] = apartments[j];
        }
      }
    }

    if(event.detail.jsonData.view360s) {
      const views360 = event.detail.jsonData.view360s;
  
      for (let index = 0; index < views360.length; index++) {
        const view360 = views360[index];
        orbViews.push(view360)
      }
    }


    await this.setState({
      maxZoom: event.detail.jsonData.maxZoom,
      minZoom: event.detail.jsonData.minZoom,
      cameraZoom: event.detail.jsonData.minZoom,
      calibratorEnabled: event.detail.jsonData.enableCalibrator,
      jsonData: event.detail.jsonData,

      isBalconFilterShown:
        event.detail.jsonData.skinEditor.balconyFilterVisibility,
      isGardenFilterVisibility:
        event.detail.jsonData.skinEditor.gardenFilterVisibility,
      isParkingFilterVisibility:
        event.detail.jsonData.skinEditor.parkingFilterVisibility,
      isTerraceFilterVisibility:
        event.detail.jsonData.skinEditor.terraceFilterVisibility,
      isGalleryFilterShown:
        event.detail.jsonData.skinEditor.galleryFilterVisibility,  
      isPricingFilterShown:
        event.detail.jsonData.skinEditor.pricingFilterVisibility,
      isGarageFilterShown:
        event.detail.jsonData.skinEditor.garageFilterVisibility,
      isDuplexFilterShown:
        event.detail.jsonData.skinEditor.duplexFilterVisibility,

      priceValues: [minPrice, maxPrice],
      priceFilter: { min: minPrice, max: maxPrice },
      quadratureValues: [minQuadrature, maxQuadrature],
      quadratureFilter: { min: minQuadrature, max: maxQuadrature },

      loaderImg: event.detail.jsonData.loaderImageUrl,
      threeSixtyImageUrl: event.detail.jsonData.threeSixtyImageUrl,
      loadingScreen: event.detail.jsonData.loadingScreenBackgroundUrl,

      maxColumns: event.detail.jsonData.maxColumns,
      currentRow: event.detail.jsonData.currentRow,
      currentState: event.detail.jsonData.currentState,
      rowsPerState: event.detail.jsonData.rowsPerState,
      currentColumn: event.detail.jsonData.currentColumn,

      linkHotspots: linkHotspots,
      allApartments: allApartments,
      hotspotColors: hotspotColors,
      googleMapView: event.detail.jsonData.googleMapView,
      hotspotUnavailableColor: event.detail.jsonData.unavailableHotspotColor,

      hotspotAngle: -1 * this.angleStep * event.detail.jsonData.currentColumn,

      /* Skin Editor Properties */
      menuColor: event.detail.jsonData.skinEditor.menuColor || "rgba(14, 47, 76, 0.81)",
      menuColorSecondary: event.detail.jsonData.skinEditor.secondaryMenuColor || "rgba(163, 196, 117, 0.81)",
      clientLogo: event.detail.jsonData.skinEditor.clientLogo,
      projectLogo: event.detail.jsonData.skinEditor.projectLogo,
      customButtons: sortedButtons,
      menuVisibility: event.detail.jsonData.skinEditor.menuVisibility,
      magLogoVisible: event.detail.jsonData.skinEditor.magLogoVisible,
      compassPointer: event.detail.jsonData.skinEditor.compassArrowUrl,
      compassFrame: event.detail.jsonData.skinEditor.compassBackgroundUrl,
      compassStartingAngle:
        event.detail.jsonData.skinEditor.compassStartingAngle,

      orbViews: orbViews,
      button2DHeader: 
        event.detail.jsonData.skinEditor.button2DHeader,
      button2DBody:
        event.detail.jsonData.skinEditor.button2DBody,
      button2DImageUrl:
        event.detail.jsonData.skinEditor.button2DImage,
      button3DHeader:
        event.detail.jsonData.skinEditor.button3DHeader,
      button3DBody:
        event.detail.jsonData.skinEditor.button3DBody,
      button3DImageUrl:
        event.detail.jsonData.skinEditor.button3DImage  
    });

    // Set document title
    document.title = event.detail.jsonData.name;
    // Set Favourite Apartments
    this.setSliderBackgroundColor(event.detail.jsonData.skinEditor.menuColor);
    this.setActiveSliderBackgroundColor();
    this.fetchFavouriteApartments();
    this.setProjectFont(event.detail.jsonData.skinEditor.fontUrl);

    let setupDoneEvent = new CustomEvent("setupDefaultState", {
      detail: {
        priceValues: {
          min: minPrice,
          max: maxPrice,
        },
        quadratureValues: {
          min: minQuadrature,
          max: maxQuadrature,
        },
      },
    });

    window.dispatchEvent(setupDoneEvent);
  }

  /**
   * Changes the color of the slider background.
   * @param color Color to which the backgroud color is switched to
   */
  async setSliderBackgroundColor(color) {
    const tracks = await document.getElementsByClassName(
      "input-range__track--background"
    );

    for (let i = 0; i < tracks.length; i++) {
      let track = tracks[i];
      track.style.backgroundColor = stringHelper.removeAplhaFromColor(color);
    }
  }

  setActiveSliderBackgroundColor() {
    const tracks = document.getElementsByClassName("input-range__track--active");

    for (let i = 0; i < tracks.length; i++) {
      let track = tracks[i];
      track.style.backgroundColor = stringHelper.removeAplhaFromColor(this.state.menuColorSecondary);
    }
  }

  /**
   * Function that is bound to an event and updates the loading proggress.
   * @param event Event parameter
   */
  async updateLoadingProgress(event) {
    await this.setState({
      loadingProgress: event.detail.newValue,
    });
    if (this.state.loadingProgress === 100) {
      this.attachDragEvents();
      this.attachCustomEvents();
      let customEvent = new CustomEvent("LoadingFinished");
      window.dispatchEvent(customEvent);
    }
  }

  /**
   * Displays the showApartment page.
   * @param event Event parameter
   */
  async toggleApartmentInfo(event) {
    let apartmentKey = event.detail.apartmentKey;

    let apartmentCount =
      this.state.jsonData.states[this.state.currentState].apartments.length;
    if (apartmentCount <= 0) {
      console.warn(`State ${this.state.currentState} has no apartments!`);
      return;
    }

    this.setClickedApartmentState(apartmentCount, apartmentKey);
    await this.setState({
      apartmentClickedInfo: this.state.allApartments[apartmentKey],
      currentHotspotColumn: 0,
      isApartmentInfoShown: true,
      isApartment3DCanvasShown: false,
      isClickedOn3D: false,
    });

    let e = new CustomEvent("ApartmentInfoSet", {
      detail: {
        clickedApartment: this.state.apartmentClickedInfo,
      },
    });

    window.dispatchEvent(e);
  }


  /**
   * Puts the clicked apartments information into state.
   * @param apartmentCount Number of apartments in that state
   * @param apartmentKey Key of the clicked apartment
   */
  setClickedApartmentState(apartmentCount, apartmentKey) {
    for (var i = 0; i < apartmentCount; i++) {
      if (
        this.state.jsonData.states[this.state.currentState].apartments[i]
          .key === apartmentKey
      ) {
        this.state.apartmentClickedInfo =
          this.state.jsonData.states[this.state.currentState].apartments[i];
        this.state.maxApartmentColumns =
          this.state.apartmentClickedInfo.highResUrls.length;
        break;
      }
    }
  }

  /**
   * Turns off the display of the showApartment page.
   */
  async toggleApartmentInfoOff() {
    this.dettachDragEventsForApartment();

    this.renderMainCanvas();
    await this.setState({
      isApartmentInfoShown: false,
      apartmentClickedInfo: undefined,
    });
  }

  /**
   * Increases zoom value in main scene.
   */
  increaseCameraZoom() {
    if (this.state.cameraZoom + this.state.zoomStep > this.state.maxZoom) {
      return;
    }
    this.setState({
      cameraZoom: (this.state.cameraZoom += this.state.zoomStep),
    });
  }

  /**
   * Decreases zoom value in main scene.
   */
  decreaseCameraZoom() {
    if (this.state.cameraZoom - this.state.zoomStep < this.state.minZoom) {
      return;
    }
    this.setState({
      cameraZoom: (this.state.cameraZoom -= this.state.zoomStep),
    });
  }

  /**
   * Turns on display of google map view.
   */
  async toggleMapOn() {
    await this.setState({ isMapShown: true });
    this.dettachDragEvents();
  }

  /**
   * Turns off display of google map view.
   */
  toggleMapOff() {
    this.setState({ isMapShown: false });
    this.attachDragEvents();
  }

  /**
   * Sets which apartment is being viewed in one of the two ApartmentViewerBoxes in the compare page.
   * @param id Id of the apartment
   * @param selector Number which identifies to which container the apartment is being set
   */
  setApartmentViewed(id, selector) {
    if (selector === 1) {
      this.setState({ firstApartmentViewer: id });
      return;
    }
    this.setState({ secondApartmentViewer: id });
  }

  /**
   * Turns fullscreen on/off depending which value is passed.
   * @param isFullscreen A value to which the fullscreen state will be set to
   */
  async setFullscreen(isFullscreen) {
    await this.setState({ isFullscreen });
  }

  /**
   * Toggles fullscreen on/off.
   */
  toggleFullscreen() {
    this.setState({ isFullscreen: !this.state.isFullscreen });
  }

  /**
   * Adds filter values to a filter array.
   * If a value is already present if is removed.
   * Triggers a render.
   * @param filter Filter value which is being added/removed
   */
  setCurrentFilter(filter) {
    const event = new CustomEvent("sceneNeedsRender");

    let fullscreenNode = document.getElementById("full-screenable-node");
    fullscreenNode.dispatchEvent(event);

    if (this.state.currentFilter.includes(filter)) {
      this.state.currentFilter.forEach((tag, index) => {
        if (tag === filter) {
          this.state.currentFilter.splice(index, 1);
        }
      });
    } else {
      this.state.currentFilter.push(filter);
    }
  }

  /**
   * Adds a tag to an array of tags used for filtering.
   * If a value is already present if is removed.
   * Triggers a render.
   * @param newTag Tag which is being added/removed
   */
  setCurrentTag(newTag) {
    const event = new CustomEvent("sceneNeedsRender");

    if (this.state.currentTags.includes(newTag)) {
      this.state.currentTags.forEach((tag, index) => {
        if (tag === newTag) {
          this.state.currentTags.splice(index, 1);
        }
      });
    } else {
      this.state.currentTags.push(newTag);
    }
    let fullscreenNode = document.getElementById("full-screenable-node");
    fullscreenNode.dispatchEvent(event);
  }

  async setPriceFilter(valueRange) {
    await this.setState({ priceFilter: valueRange });
  }

  async setQuadratureFilter(valueRange) {
    await this.setState({ quadratureFilter: valueRange });
  }

  /**
   * Changes the current column and angle of hotspots.
   */
  async panLeft() {
    if (this.state.waitForImage || this.state.isMapShown) return;

    //Rotate hotspot logic
    const angleStep = (2 * Math.PI) / this.state.maxColumns;
    this.setState({
      hotspotAngle: (this.state.hotspotAngle += angleStep),
    });

    //State logic
    if (this.state.currentColumn === 0) {
      await this.setState((state) => {
        return { currentColumn: state.maxColumns - 1 };
      });
    } else {
      await this.setState((state) => {
        return { currentColumn: state.currentColumn - 1 };
      });
    }
  }

  /**
   * Changes the current column and angle of hotspots.
   */
  async panRight() {
    if (this.state.waitForImage || this.state.isMapShown) return;

    const angleStep = (2 * Math.PI) / this.state.maxColumns;
    this.setState({
      hotspotAngle: (this.state.hotspotAngle -= angleStep),
    });

    if (this.state.currentColumn === this.state.maxColumns - 1) {
      await this.setState((state) => {
        return { currentColumn: 0 };
      });
    } else {
      await this.setState((state) => {
        return { currentColumn: state.currentColumn + 1 };
      });
    }
  }

  /**
   * Changes the current row.
   */
  async panUp() {
    if (this.state.waitForImage || this.state.isMapShown) return;
    if (
      this.state.rowsPerState[this.state.currentState] - 1 ===
      this.state.currentRow
    ) {
      await this.setState((state) => {
        return { currentRow: 0 };
      });
    } else {
      await this.setState((state) => {
        return { currentRow: state.currentRow + 1 };
      });
    }
  }

  /**
   * Changes the current row.
   */
  async panDown() {
    if (this.state.waitForImage || this.state.isMapShown) return;
    if (this.state.currentRow === 0) {
      await this.setState((state) => {
        return {
          currentRow: state.rowsPerState[state.currentState] - 1,
        };
      });
    } else {
      await this.setState((state) => {
        return { currentRow: state.currentRow - 1 };
      });
    }
  }

  /**
   * Changes the current floor to the passed parameter.
   * @param floor Which floor/state to switch to
   */
  async updateCurrentFloor(floor) {
    if (this.state.waitForImage || this.state.isMapShown) return;

    await this.setState({
      currentState: floor,
      currentRow: 0,
    });
  }

  /**
   * Finds the floor whose name has been passed in the parameter and changes currentState to its id.
   * @param stateName Name of the state which we are switching to
   */
  updateCurrentFloorByButton(stateName) {
    if (this.state.isMapShown) return;
    this.state.jsonData.states.forEach((state) => {
      if (state.name === stateName) {
        this.setState({
          currentState: state.id,
          currentRow: 0,
        });
      }
    });
  }

  /**
   * Changes the current column for the apartment 3d view.
   */
  async panLeftApartment() {
    if (this.state.currentHotspotColumn === 0) {
      await this.setState((state) => {
        return {
          currentHotspotColumn: state.maxApartmentColumns - 1,
        };
      });
    } else {
      await this.setState((state) => {
        return {
          currentHotspotColumn: state.currentHotspotColumn - 1,
        };
      });
    }
    this.updateApartmentTextureHandler();
  }

  /**
   * Changes the current column for the apartment 3d view.
   */
  async panRightApartment() {
    if (
      this.state.currentHotspotColumn ===
      this.state.maxApartmentColumns - 1
    ) {
      await this.setState((state) => {
        return { currentHotspotColumn: 0 };
      });
    } else {
      await this.setState((state) => {
        return {
          currentHotspotColumn: state.currentHotspotColumn + 1,
        };
      });
    }
    this.updateApartmentTextureHandler();
  }

  /**
   * Function that sets the event value to state.
   * @param event Event parameter
   */
  blockStateControls = (event) => {
    this.state.waitForImage = event.detail.value;
  };

  /**
   * Sets isMouseOnSidebar to true.
   */
  onSideBarMouseEnter() {
    if (this.state.isMouseOnSideBar) return;
    this.setState({ isMouseOnSideBar: true });
  }

  /**
   * Sets isMouseOnSidebar to false.
   */
  onSideBarMouseLeave() {
    if (this.state.isMouseOnSideBar) {
      this.setState({ isMouseOnSideBar: false });
    }
  }

  /**
   * Attaches event listeners.
   */
  attachEventListeners() {
    let rootElement = document.getElementById("root");
    rootElement.addEventListener("setJsonData", (event) => {
      this.setJsonData(event);
    });
    rootElement.addEventListener("updateLoadingProgress", (event) => {
      this.updateLoadingProgress(event);
    });

    window.addEventListener("addFavourite", (event) => {
      this.addFavourite(event.detail.key);
    });
    window.addEventListener("removeFavourite", (event) => {
      this.removeFavorite(event.detail.key);
    });

    window.addEventListener("keydown", (e) => {
      if (e.key === "F11") {
        e.preventDefault();
        this.toggleFullscreen();
      }
    });

    window.addEventListener("setTargetDefaultPosition", (event) => {
      this.setState({ targetDefaultPosition: event.detail.position });
    });
  }

  /**
   * Attaches custom events.
   */
  attachCustomEvents() {
    if (this.state.menuVisibility) {
      let sideMenu = document.getElementById("side-menu");

      sideMenu.addEventListener("mouseover", (event) => {
        this.onSideBarMouseEnter();
      });

      sideMenu.addEventListener("mouseleave", (event) => {
        this.onSideBarMouseLeave();
      });
    }

    let fullscreenNode = document.getElementById("full-screenable-node");

    fullscreenNode.addEventListener("imageIsLoading", (e) =>
      this.blockStateControls(e)
    );

    fullscreenNode.addEventListener("openApartmentWindow", (event) => {
      this.toggleApartmentInfo(event);
    });

    fullscreenNode.addEventListener("toggleApartmentControls", (event) => {
      this.attachDragEventsForApartment();

      this.updateApartmentTextureHandler();
    });
  }

  /*
   * Attaches Event listeners on fullscreen node for mouse movement and click logic.
   */
  attachDragEvents() {
    let fullscreenNode = document.getElementById("full-screenable-node");
    // Mouse events
    fullscreenNode.addEventListener("wheel", this.wheelHandler);
    fullscreenNode.addEventListener("mousedown", this.mousedownHandler);
    fullscreenNode.addEventListener("mouseup", this.mouseupHandler);
    fullscreenNode.addEventListener("mouseout", this.mouseoutHandler);

    fullscreenNode.addEventListener("touchstart", this.touchDownHandler);
    fullscreenNode.addEventListener("touchend", this.touchUpHandler);
    fullscreenNode.addEventListener("touchcancel", this.touchcancelHandler);
  }

  /*
   * Dettaches Event listeners on fullscreen node for mouse movement and click logic.
   */
  dettachDragEvents() {
    let fullscreenNode = document.getElementById("full-screenable-node");

    fullscreenNode.removeEventListener("wheel", this.wheelHandler);
    fullscreenNode.removeEventListener("mousedown", this.mousedownHandler);
    fullscreenNode.removeEventListener("mouseup", this.mouseupHandler);
    fullscreenNode.removeEventListener("mouseout", this.mouseoutHandler);

    fullscreenNode.removeEventListener("touchstart", this.touchDownHandler);
    fullscreenNode.removeEventListener("touchend", this.touchUpHandler);
    fullscreenNode.removeEventListener("touchcancel", this.touchcancelHandler);
  }

  /**
   * Attaches event listeners for apartment 3D view.
   */
  attachDragEventsForApartment() {
    let fullscreenNode = document.getElementById("full-screenable-node");

    fullscreenNode.addEventListener(
      "mousedown",
      this.mousedownApartmentHandler
    );
    fullscreenNode.addEventListener("mouseup", this.mouseupApartmentHandler);
    fullscreenNode.addEventListener("mouseout", this.mouseoutApartmentHandler);

    fullscreenNode.addEventListener(
      "touchstart",
      this.touchdownApartmentHandler
    );
    fullscreenNode.addEventListener("touchend", this.touchupApartmentHandler);
    fullscreenNode.addEventListener(
      "touchcancel",
      this.touchoutApartmentHandler
    );
  }

  /**
   * Dettaches event listeners for apartment 3D view.
   */
  dettachDragEventsForApartment() {
    let fullscreenNode = document.getElementById("full-screenable-node");

    fullscreenNode.removeEventListener(
      "mousedown",
      this.mousedownApartmentHandler
    );
    fullscreenNode.removeEventListener("mouseup", this.mouseupApartmentHandler);
    fullscreenNode.removeEventListener(
      "mouseout",
      this.mouseoutApartmentHandler
    );

    fullscreenNode.removeEventListener(
      "touchstart",
      this.touchdownApartmentHandler
    );
    fullscreenNode.removeEventListener(
      "touchend",
      this.touchupApartmentHandler
    );
    fullscreenNode.removeEventListener(
      "touchcancel",
      this.touchoutApartmentHandler
    );
  }

  /**
   * Handles mousewheel events.
   * @param event Event parameter
   */
  wheelHandler = (event) => {
    if (
      this.state.isApartmentInfoShown ||
      event.ctrlKey ||
      this.state.isMouseOnSideBar ||
      this.state.isMapShown
    )
      return;
    if (event.deltaY < 0) {
      this.increaseCameraZoom();
      return;
    }
    this.decreaseCameraZoom();
  };

  /**
   * Handles the mousedown event.
   * @param event Event parameter
   */
  mousedownHandler = (event) => {
    if (
      this.state.apartmentClickedInfo !== undefined ||
      this.state.isMouseOnSideBar
    )
      return;
    this.state.startDragPosition = [event.clientX, event.clientY];
    this.state.isClicked = true;

    // Attach mousemove event
    let canvas = document.getElementById("full-screenable-node");
    canvas.addEventListener("mousemove", this.mousemoveHandler);
  };

  /**
   * Handles the mouseup event.
   */
  mouseupHandler = () => {
    if (this.state.apartmentClickedInfo !== undefined) {
      return;
    }
    this.state.startDragPosition = [0, 0];
    this.state.isClicked = false;
    if (this.state.isDragging) this.setState({ isDragging: false });

    // Dettach mousemove event
    let canvas = document.getElementById("full-screenable-node");
    canvas.removeEventListener("mousemove", this.mousemoveHandler);
  };

  /**
   * Handles the mouseout event.
   */
  mouseoutHandler = () => {
    if (this.state.apartmentClickedInfo !== undefined) return;

    this.state.isClicked = false;
    this.state.dragPositionX = 0;
    this.state.dragPositionY = 0;
    if (this.state.isDragging) this.setState({ isDragging: false });
  };

  /**
   * Handles the mousemove event.
   * @param event Event parameter
   */
  mousemoveHandler = (event) => {
    if (!this.state.isClicked || this.state.apartmentClickedInfo !== undefined)
      return;

    let pointStart = [
      this.state.startDragPosition[0],
      this.state.startDragPosition[1],
    ];
    let pointEnd = [event.clientX, event.clientY];

    let distanceX = pointEnd[1] - pointStart[1];
    let distanceY = pointEnd[0] - pointStart[0];

    let dragDistance = Math.sqrt(
      Math.pow(distanceX, 2) + Math.pow(distanceY, 2)
    );

    if (dragDistance < this.state.jsonData.fixedDrag) return;

    if (!this.state.isDragging) {
      this.setState({ isDragging: true });
    }

    // Checks which lenght is longer (if lenght of X is greater then lenght of Y) it means that end point is closer to the 'Y' axis.
    if (
      Math.abs(distanceY) < Math.abs(distanceX) &&
      dragDistance >= this.state.jsonData.fixedDrag * 2
    ) {
      if (distanceX > 0) this.panUp();
      else this.panDown();
    } else {
      if (distanceY > 0) this.panLeft();
      else this.panRight();
    }

    // Move the starting position to the end position.
    this.state.startDragPosition = pointEnd;
  };

  /**
   * Handles the touchup event.
   */
  touchUpHandler = () => {
    if (this.state.apartmentClickedInfo !== undefined) {
      return;
    }
    this.state.startDragPosition = [0, 0];
    this.state.isClicked = false;
    if (this.state.isDragging) this.setState({ isDragging: false });

    let canvas = document.getElementById("full-screenable-node");
    canvas.removeEventListener("touchmove", this.touchmoveHandler);
  };

  /**
   * Handles the touchdown event.
   * @param event Event parameter
   */
  touchDownHandler = (event) => {
    if (
      this.state.apartmentClickedInfo !== undefined ||
      this.state.isSideBarOpen
    )
      return;
    this.state.startDragPosition = [event.clientX, event.clientY];
    this.state.isClicked = true;

    let canvas = document.getElementById("full-screenable-node");
    canvas.addEventListener("touchmove", this.touchmoveHandler);
  };

  /**
   * Handles the touchmove event.
   * @param event Event parameter
   */
  touchmoveHandler = (event) => {
    if (!this.state.isClicked || this.state.apartmentClickedInfo !== undefined)
      return;

    let pointStart = [
      this.state.startDragPosition[0],
      this.state.startDragPosition[1],
    ];
    let pointEnd = [event.touches[0].clientX, event.touches[0].clientY];

    // Gets the lenght of the 'X' axis between start and end point
    let distanceX = pointEnd[1] - pointStart[1];
    // Gets the lenght of the 'Y' axis between start and end point
    let distanceY = pointEnd[0] - pointStart[0];

    // Gets the lenght of the end and start point.
    let dragDistance = Math.sqrt(
      Math.pow(distanceX, 2) + Math.pow(distanceY, 2)
    );

    if (dragDistance < this.state.jsonData.fixedDrag) {
      return;
    }

    // Checks which lenght is longer (if lenght of X is greater then lenght of Y) it means that end point is closer to the 'Y' axis.
    if (
      Math.abs(distanceY) < Math.abs(distanceX) &&
      dragDistance >= this.state.jsonData.fixedDrag * 2
    ) {
      if (distanceX > 0) this.panUp();
      else this.panDown();
    } else {
      if (distanceY > 0) this.panLeft();
      else this.panRight();
    }
    this.state.startDragPosition = pointEnd;
  };

  /**
   * Handles the touchcancel event.
   */
  touchcancelHandler = () => {
    if (this.state.apartmentClickedInfo !== undefined) {
      return;
    }
    this.state.startDragPosition = [0, 0];
    this.state.isClicked = true;
    if (this.state.isDragging) this.setState({ isDragging: false });
  };

  /**
   * Handles the mousedown event for the apartment 3D view.
   * @param event Event parameter
   */
  mousedownApartmentHandler = (event) => {
    if (this.state.apartmentClickedInfo === undefined) return;
    this.state.startDragPosition = [event.clientX, event.clientY];
    this.state.isClicked = true;

    let canvas = document.getElementById("full-screenable-node");
    canvas.addEventListener("mousemove", this.mousemoveApartmentHandler);
  };

  /**
   * Handles the mouseup event for the apartment 3D view.
   */
  mouseupApartmentHandler = () => {
    if (this.state.apartmentClickedInfo === undefined) {
      return;
    }
    this.state.startDragPosition = [0, 0];
    this.state.isClicked = false;

    let canvas = document.getElementById("full-screenable-node");
    canvas.removeEventListener("mousemove", this.mousemoveApartmentHandler);
  };

  /**
   * Handles the mouseout event for the apartment 3D view.
   */
  mouseoutApartmentHandler = () => {
    if (this.state.apartmentClickedInfo === undefined) return;

    this.state.isClicked = false;
    this.state.dragPositionX = 0;
    this.state.dragPositionY = 0;

    let canvas = document.getElementById("full-screenable-node");
    canvas.removeEventListener("mousemove", this.mousemoveApartmentHandler);
  };

  /**
   * Handles the mousemove event for the apartment 3D view.
   * @param event Event parameter
   */
  mousemoveApartmentHandler = (event) => {
    if (!this.state.isClicked) return;

    let pointStart = [
      this.state.startDragPosition[0],
      this.state.startDragPosition[1],
    ];
    let pointEnd = [event.clientX, event.clientY];

    let distanceX = pointEnd[1] - pointStart[1];
    let distanceY = pointEnd[0] - pointStart[0];

    // Gets the lenght of the end and start point.
    let dragDistance = Math.sqrt(
      Math.pow(distanceX, 2) + Math.pow(distanceY, 2)
    );

    if (dragDistance < this.state.jsonData.fixedDrag) {
      return;
    }

    // Checks which lenght is longer (if lenght of X is greater then lenght of Y) it means that end point is closer to the 'Y' axis.
    if (Math.abs(distanceY) > Math.abs(distanceX)) {
      if (distanceY > 0) this.panLeftApartment();
      else this.panRightApartment();
    }

    // Move the starting position to the end position.
    this.state.startDragPosition = pointEnd;
  };

  /**
   * Handles the touchdown event for the apartment 3D view.
   * @param event Event parameter
   */
  touchdownApartmentHandler = (event) => {
    if (this.state.apartmentClickedInfo === undefined || this.state.isMapShown)
      return;

    this.state.startDragPosition = [event.clientX, event.clientY];
    this.state.isClicked = true;

    let canvas = document.getElementById("full-screenable-node");
    canvas.addEventListener("touchmove", this.touchmoveApartmentHandler);
  };

  /**
   * Handles the touchup event for the apartment 3D view.
   */
  touchupApartmentHandler = () => {
    if (this.state.apartmentClickedInfo === undefined) {
      return;
    }
    this.state.startDragPosition = [0, 0];
    this.state.isClicked = false;

    let canvas = document.getElementById("full-screenable-node");
    canvas.removeEventListener("touchmove", this.touchmoveApartmentHandler);
  };

  /**
   * Handles the touchout event for the apartment 3D view.
   */
  touchoutApartmentHandler = () => {
    if (this.state.apartmentClickedInfo === undefined) return;

    this.state.isClicked = false;
    this.state.dragPositionX = 0;
    this.state.dragPositionY = 0;

    let canvas = document.getElementById("full-screenable-node");
    canvas.removeEventListener("touchmove", this.touchmoveApartmentHandler);
  };

  /**
   * Handles the touchmove event for the apartment 3D view.
   * @param event Event parameter
   */
  touchmoveApartmentHandler = (event) => {
    if (!this.state.isClicked) return;
    let pointStart = [
      this.state.startDragPosition[0],
      this.state.startDragPosition[1],
    ];
    let pointEnd = [event.touches[0].clientX, event.touches[0].clientY];

    let distanceX = pointEnd[1] - pointStart[1];
    let distanceY = pointEnd[0] - pointStart[0];

    // Gets the lenght of the end and start point.
    let dragDistance = Math.sqrt(
      Math.pow(distanceX, 2) + Math.pow(distanceY, 2)
    );

    if (dragDistance < this.state.jsonData.fixedDrag) {
      return;
    }
    // Checks which lenght is longer (if lenght of X is greater then lenght of Y) it means that end point is closer to the 'Y' axis.
    if (Math.abs(distanceY) > Math.abs(distanceX)) {
      if (distanceY > 0) this.panLeftApartment();
      else this.panRightApartment();
    }
    // Move the starting position to the end position.
    this.state.startDragPosition = pointEnd;
  };

  updateSceneSettings(cameraDistanceMultiplier, hotspotScale) {
    if (cameraDistanceMultiplier !== 0) {
      this.setState({
        cameraDistanceMultiplier: parseFloat(cameraDistanceMultiplier),
      });
    }
    if (hotspotScale !== 0) {
      this.setState({ hotspotScale: parseFloat(hotspotScale) });
    }

    let fullscreenNode = document.getElementById("full-screenable-node");
    fullscreenNode.dispatchEvent(new CustomEvent("sceneNeedsRender"));
  }

  /**
   * Increases current floor by one.
   */
  increaseCurrentFloor() {
    const currentFloorPlacement =
      this.state.jsonData.states[this.state.currentState].placementOrder;

    this.state.jsonData.states.forEach((state, index) => {
      if (state.placementOrder === currentFloorPlacement + 1)
        this.updateCurrentFloor(index);
    });
  }
  /**
   * Decreases current floor by one.
   */
  decreaseCurrentFloor() {
    const currentFloorPlacement =
      this.state.jsonData.states[this.state.currentState].placementOrder;

    this.state.jsonData.states.forEach((state, index) => {
      if (state.placementOrder === currentFloorPlacement - 1)
        this.updateCurrentFloor(index);
    });
  }
  //   <======== Action functions for buttons ========>
  /**
   * Shows/hides elements of the ui by changing their display variables.
   * @param elementName Name of element we are displaying/hiding
   * @param showOrHideBoolean Boolean that dictates whether we show/hide a component
   */
  handleShowElement(elementName, showOrHideBoolean) {
    if (elementName === "stateView") return;

    switch (elementName) {
      case "mapView":
        if (showOrHideBoolean) {
          this.toggleMapOn();
          return;
        }
        this.toggleMapOff();
        break;
      case "compareFavouritesView":
        if (showOrHideBoolean) {
          this.dettachDragEvents();
          let event = new CustomEvent("openCompareWindow");
          window.dispatchEvent(event);
        }

        this.setState({ isCompareShown: showOrHideBoolean });
        if (showOrHideBoolean) this.setState({ isApartmentInfoShown: false });
        break;
      case "filterMenuView":
        this.setState({ isFilterMenuShown: showOrHideBoolean });

        break;
      case "investorLogoView":
        this.setState({ isInvestorLogoShown: showOrHideBoolean });

        break;
      case "fullscreenButton":
        this.setState({ isFullscreenButtonShown: showOrHideBoolean });

        break;
      case "verticalUpButton":
        this.setState({ isUpButtonShown: showOrHideBoolean });

        break;
      case "verticalDownButton":
        this.setState({ isDownButtonShown: showOrHideBoolean });

        break;
      case "horizontalLeftButton":
        this.setState({ isLeftButtonShown: showOrHideBoolean });

        break;
      case "horizontalRightButton":
        this.setState({ isRightButtonShown: showOrHideBoolean });

        break;
      case "compassButton":
        this.setState({ isCompasShown: showOrHideBoolean });

        break;
      case "apartmentFullscreenButton":
        this.setState({ isApartmentFullscreenButtonShown: showOrHideBoolean });
        break;
      case "apartmentViewButton":
        this.setState({ apartmentViewButton: showOrHideBoolean });
        break;
      case "apartment3DViewButton":
        this.setState({ apartment3DViewButton: showOrHideBoolean });
        break;
      case "compareApratmentViewButton":
        this.setState({
          compare2DApartmentButtonActive: true,
          compare3DApartmentButtonActive: false
        });  
        break;
      case "compareApartment3DViewButton": 
        this.setState({
          compare2DApartmentButtonActive: true,
          compare3DApartmentButtonActive: false,
        });  
        break;
      case "stateMenuView":
        this.setState({ isMainMenuShown: showOrHideBoolean });
        break;
      case "apartment3DView":
        if (this.state.apartmentClickedInfo.highResUrls.length <= 0) return;
        if (showOrHideBoolean) {
          this.attachDragEventsForApartment();
          // Update texture
          this.updateApartmentTextureHandler();
        }
        this.setState({ isApartment3DCanvasShown: showOrHideBoolean });
        break;
      case "orbViewScene": 
        this.setState({ shouldDisplayOrbViewScene: showOrHideBoolean });
      break;  
      default:
        console.error("no element found");
        break;
    }
  }
}
